<template>
  <div>
    <Pane title="新增项目跟踪"/>

    <div class="container">
      <a-form
          :form="form"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 12 }"
          :colon="false"
      >
        <div class="title" style="margin-top: 0">基本信息</div>
        <div class="wrapper">
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="项目名称">
                <a-input v-decorator="['projectName', { rules: [{ required: true, message: '请输入项目名称' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="项目类型">
                <a-select v-decorator="['projectType']" placeholder>
                  <a-select-option v-for="item in projectTrackType" :key="item.value" :value="item.value">{{
                      item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="项目地点">
                <a-input v-decorator="['projectLocation']"/>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="分类">
                <a-select v-decorator="['category']" placeholder>
                  <a-select-option v-for="item in trackCategory" :key="item.value" :value="item.value">{{
                      item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="业主单位名称">
                <a-input v-decorator="['ownerCompanyName']"/>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="预计合同金额(万元)">
                <a-input-number v-decorator="['expectedAmount']" :min="0" style="width: 100%"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="预计落地/开标时间">
                <a-input v-decorator="['expectedTime']"/>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="概率(%)">
                <a-input-number v-decorator="['probability']" :min="0" :max="100" style="width: 100%"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="是否介入方案">
                <a-switch v-decorator="['isIntervene', { valuePropName: 'checked' }]"/>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="配合生产院">
                <a-select
                    mode="multiple"
                    show-search
                    :filter-option="$selectFilterOption"
                    v-decorator="['coopCompanyName']"
                    placeholder
                >
                  <a-select-option v-for="item in productionOrgList" :key="item.id" :value="item.uniqueName">
                    {{ item.uniqueName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="生产院负责人">
                <EmployeeSelector
                    :single="false"
                    @change="(arr) => { coopLeaderList = arr; }"
                    :value="coopLeaderList"
                >
                  <a-button block style="text-align: left">
                    {{ coopLeaderList.length ? coopLeaderList.map(i => i.name).join('、') : '请选择' }}
                  </a-button>
                </EmployeeSelector>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="专职经营人员">
                <EmployeeSelector
                    :single="false"
                    @change="(arr) => { fulltimeManagerList = arr; }"
                    :value="fulltimeManagerList"
                >
                  <a-button block style="text-align: left">
                    {{ fulltimeManagerList.length ? fulltimeManagerList.map(i => i.name).join('、') : '请选择' }}
                  </a-button>
                </EmployeeSelector>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-item label="概率原因" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <a-textarea v-decorator="['probabilityReason']" :auto-size="{ minRows: 3 }"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-item label="备注/当前阶段" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <a-textarea v-decorator="['remark']" :auto-size="{ minRows: 3 }"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <div style="border-top: none;text-align: center;margin: 20px 0;">
          <a-row>
            <a-col :lg="24" :md="24" :sm="24">
              <a-space>
                <a-button type="primary" @click="handleSave" :loading="loading">保存</a-button>
                <a-button @click="$router.back()">返回</a-button>
              </a-space>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import watermark from "@/mixins/watermark";
import EmployeeSelector from "@/components/employee-selector";
import {addProjectTrack} from "@/api/market/projectTrack";
import {fetchDetailProduct} from "@/api/setting/organization";

export default {
  mixins: [watermark],
  components: {EmployeeSelector},
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      coopLeaderList: [],
      fulltimeManagerList: [],
      productionOrgList: [],
    };
  },
  created() {
    fetchDetailProduct().then((res) => {
      this.productionOrgList = Array.isArray(res) ? res : (res.list || []);
    });
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    projectTrackType() {
      return this.findDataDict("projectTrackType");
    },
    trackCategory() {
      return this.findDataDict("trackCategory");
    },
  },
  methods: {
    handleSave() {
      this.form.validateFields((err, values) => {
        if (err) return;
        this.loading = true;
        addProjectTrack({
          ...values,
          coopCompanyName: (values.coopCompanyName || []).join(","),
          coopLeaderName: this.coopLeaderList.map((i) => i.name).join(","),
          coopLeaderId: this.coopLeaderList.map((i) => i.userId).join(","),
          fulltimeManagerName: this.fulltimeManagerList.map((i) => i.name).join(","),
          fulltimeManagerId: this.fulltimeManagerList.map((i) => i.userId).join(","),
        })
            .then(() => {
              this.$router.back();
            })
            .finally(() => {
              this.loading = false;
            });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.wrapper {
  background-color: #f9f9f9;
  padding-top: 24px;
  padding-bottom: 8px;
}

.title {
  font-weight: bold;
  font-size: 17px;
  margin: 12px 0;
}

.center {
  margin-top: 80px;
}
</style>
